import { toFa } from '../utils/faFormat';

export const STAGE_STATES = {
  locked: { label: 'قفل', tone: 'locked', icon: 'lock' },
  open: { label: 'آمادهٔ ثبت مدارک', tone: 'ready', icon: 'camera' },
  submitted: { label: 'ارسال شد', tone: 'waiting', icon: 'clock' },
  ai_reviewing: { label: 'در حال بررسی', tone: 'waiting', icon: 'clock' },
  awaiting_supervisor: { label: 'در انتظار تأیید ناظر', tone: 'waiting', icon: 'clock' },
  in_review: { label: 'در حال بررسی', tone: 'waiting', icon: 'clock' },
  passed: { label: 'تأیید شد', tone: 'passed', icon: 'check' },
  failed: { label: 'نیاز به اصلاح', tone: 'failed', icon: 'alert' },
  skipped: { label: 'رد شده توسط مدیر', tone: 'passed', icon: 'check' },
};
export function stageTime(time) {
  return time ? new Date(time).toLocaleString('fa-IR', { hour: '2-digit', minute: '2-digit' }) : 'زمان ثبت‌شده';
}
export function stageWaitingLabel(stage, now = Date.now()) {
  if (stage.review_phase !== 'human' && stage.state !== 'awaiting_supervisor') return 'در حال بررسی';
  if (stage.review_mode === 'ai_only') return 'در انتظار بررسی';
  const minutes = Math.max(0, Math.floor((now - new Date(stage.waiting_since || now).getTime()) / 60000));
  return `در انتظار ناظر از ${toFa(minutes)} دقیقه`;
}
export function installerStageState(stage, now) {
  const state = STAGE_STATES[stage.state] || STAGE_STATES.locked;
  if (['in_review', 'awaiting_supervisor', 'ai_reviewing', 'submitted'].includes(stage.state)) return { ...state, label: stageWaitingLabel(stage, now) };
  if (stage.state === 'passed' && stage.decided_by === 'ai') return { ...state, label: 'تأیید شد (بررسی خودکار)' };
  return state;
}
